import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Dropdown from "../basic/Dropdown";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { COLORS } from "../../constants";
import { Container } from "@mui/system";

const DesktopMakeModelYearForm = ({
    makeOptions,
  handleUserVehicleChange,
  loading,
  variantOptions,
  yearOptions,
  modelOptions,
  userInput,
  submit,
  inputsPerRowDesktop,
  darkMode,
  handleReset,
  showHeader = true,
}) => {
  return (
    <Container disableGutters>
      {showHeader && (
        <>
          <Typography
            sx={{
              textAlign: "center",
              color: COLORS.white,
              textTransform: "uppercase",
              fontSize: "var(--font-size-l)",
            }}
          >
            Select your vehicle
          </Typography>
          <Typography
            sx={{
              mb: 3,
              textAlign: "center",
              color: COLORS.white,
              fontWeight: 300,
              fontSize: "var(--font-size-xxs)",
            }}
          >
            We have everything your car needs
          </Typography>
        </>
      )}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ flexWrap: "nowrap" }}
      >
        <Grid item xs={12 / inputsPerRowDesktop}>
          <Dropdown
            loading={loading}
            disabled={loading}
            value={userInput.make}
            onChange={handleUserVehicleChange("make")}
            options={makeOptions}
            label="Make"
            darkMode={darkMode}
          />
        </Grid>
        <Grid item xs={12 / inputsPerRowDesktop}>
          <Dropdown
            loading={loading}
            disabled={!userInput.make || loading}
            value={userInput.model}
            onChange={handleUserVehicleChange("model")}
            options={modelOptions}
            label="Model"
            darkMode={darkMode}
          />
        </Grid>
        <Grid item xs={12 / inputsPerRowDesktop}>
          <Dropdown
            loading={loading}
            disabled={(!userInput.make && !userInput.model) || loading}
            value={userInput.variant}
            onChange={handleUserVehicleChange("variant")}
            options={variantOptions}
            label="Variant"
            darkMode={darkMode}
          />
        </Grid>
        <Grid item xs={12 / inputsPerRowDesktop}>
          <Dropdown
            loading={loading}
            disabled={
              (!userInput.make &&
                !userInput.model &&
                !userInput.variant) ||
              loading
            }
            value={userInput.year}
            onChange={handleUserVehicleChange("year")}
            options={yearOptions}
            label="Year"
            darkMode={darkMode}
          />
        </Grid>

        <Grid
          item
          xs="auto"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Button
            variant="contained"
            onClick={submit}
            size="small"
            color="error"
            type="button"
            disabled={loading}
            startIcon={<SearchIcon />}
            sx={{
              backgroundColor: COLORS.themeYellow,
              color: COLORS.darkText,
              whiteSpace: "nowrap",
              padding: "0.5em",
              height: 50,
              display: "flex",
              alignItems: "center",
              boxSizing: "border-box",
              borderRadius: "2px",
              fontWeight: "500",
              fontFamily: "Rubik",
              "& .MuiButton-startIcon .MuiSvgIcon-root": {
                fontSize: "1.2rem",
              },
              "&:hover": {
                backgroundColor: COLORS.themeBlack,
                color: COLORS.themeYellow,
              },
            }}
          >
            SEARCH
          </Button>
          <Button
            variant="outlined"
            onClick={handleReset}
            size="small"
            disabled={loading}
            startIcon={<RestartAltIcon />}
            sx={{
              backgroundColor: COLORS.themeYellow,
              color: COLORS.darkText,
              whiteSpace: "nowrap",
              padding: "0.5em",
              height: 50,
              display: "flex",
              boxSizing: "border-box",
              borderRadius: "2px",
              "& .MuiButton-startIcon": {
                margin: 0,
                fontSize: "1.5em",
              },
            }}
          ></Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DesktopMakeModelYearForm;
